import { PayloadAction } from '@reduxjs/toolkit';
import { PublicAssetProductState } from '../types';

const setForcedPreviewsReducer = (
  state: PublicAssetProductState,
  action: PayloadAction<{ [index: number]: string }>,
) => {
  state.forcedPreviews = action.payload;
};

export default setForcedPreviewsReducer;
